import { API_URL } from './api';
import { APP_STORE_URL, PLAY_STORE_URL } from '../components/landing/StoreBadges';
import { FALLBACK_DRIVE_LINKS } from './desktopDriveLinks';

/** Platforms the marketing site + admin App Updates panel share. */
export const APP_UPDATE_PLATFORMS = ['ANDROID', 'IOS', 'DESKTOP_MAC', 'DESKTOP_WIN'];

const FALLBACK_BY_PLATFORM = {
  ANDROID: {
    platform: 'ANDROID',
    latestVersionName: null,
    downloadUrl: PLAY_STORE_URL,
  },
  IOS: {
    platform: 'IOS',
    latestVersionName: null,
    downloadUrl: APP_STORE_URL,
  },
  DESKTOP_MAC: {
    platform: 'DESKTOP_MAC',
    latestVersionName: null,
    downloadUrl: FALLBACK_DRIVE_LINKS['MAC-ARM64'] || null,
  },
  DESKTOP_WIN: {
    platform: 'DESKTOP_WIN',
    latestVersionName: null,
    downloadUrl: FALLBACK_DRIVE_LINKS['WIN-EXE'] || FALLBACK_DRIVE_LINKS['WIN-PORTABLE'] || null,
  },
};

/**
 * Public: GET /api/app-updates/latest
 * Merges admin-saved configs with safe store/GitHub fallbacks for the website.
 */
export async function fetchLatestAppUpdates() {
  const byPlatform = { ...FALLBACK_BY_PLATFORM };
  try {
    const response = await fetch(`${API_URL}/app-updates/latest`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (response.ok) {
      const data = await response.json();
      const list = Array.isArray(data?.platforms) ? data.platforms : [];
      list.forEach((item) => {
        const platform = String(item?.platform || '').toUpperCase();
        if (!platform || !item?.downloadUrl) return;
        byPlatform[platform] = {
          platform,
          latestVersionName: item.latestVersionName || null,
          latestVersionCode: item.latestVersionCode ?? null,
          downloadUrl: String(item.downloadUrl).trim(),
          releaseNotes: item.releaseNotes || '',
          fromAdmin: true,
        };
      });
    }
  } catch {
    // Keep fallbacks when API is unreachable (static hosting / offline).
  }
  return APP_UPDATE_PLATFORMS.map((id) => byPlatform[id]).filter(Boolean);
}

export const fileLabelFromUrl = (url, versionName) => {
  try {
    const path = new URL(url).pathname;
    const base = path.split('/').filter(Boolean).pop();
    if (base) return decodeURIComponent(base);
  } catch {
    // ignore
  }
  if (versionName) return `Workloop ${versionName}`;
  return 'Workloop';
};
